import { combineReducers } from 'redux';

import {
	LoginReducer,
	HomeReducer
} from '../redux';

const rootReducer = combineReducers({
	login: LoginReducer,
	home: HomeReducer
});
export default rootReducer;

type Reducer = ReturnType<typeof rootReducer>;
export type RootState = Reducer;
